import moment from "moment";
// Moment
window["moment"] = moment;
moment.locale("da");

var dateTimeHelper = {
  formatDate: function(date) {
    if (date) {
      let now = moment(new Date());
      let yesterday = moment().subtract(1, "day");
      let dayBeforeYesterday = moment().subtract(2, "day");
      // eslint-disable-next-line
      let timeStr = window["moment"].utc(date).local().format("dddd[s]");

      if (moment(date).isSame(now, "day")) {
        return "I dag";
      } else if (moment(date).isSame(yesterday, "day")) {
        return "I går";
      } else if (moment(date).isSame(dayBeforeYesterday, "day")) {
        return "I forgårs";
      } else if (moment(date).isSame(now, "week")) {
        return "I " + timeStr;
      } else {
        return timeStr;
      }
    } else {
      return "Ingen dato";
    }
  },
  formatDateWithTime: function(date) {
    if (date) {
      let now = moment(new Date());
      let yesterday = moment().subtract(1, "day");
      let dayBeforeYesterday = moment().subtract(2, "day");
      // eslint-disable-next-line
      let timeStr = window["moment"].utc(date).local().format("[kl.] HH[.]mm");
      if (moment(date).isSame(now, "day")) {
        return "I dag " + timeStr;
      } else if (moment(date).isSame(yesterday, "day")) {
        return "I går " + timeStr;
      } else if (moment(date).isSame(dayBeforeYesterday, "day")) {
        return "I forgårs " + timeStr;
      } else if (moment(date).isSame(now, "week")) {
        return "I " + timeStr;
      } else {
        return timeStr;
      }
    } else {
      return "Ingen dato";
    }
  },
  getLocaleUTCTime: function() {
    // let date = new Date()
    let offset = new Date().getTimezoneOffset() * 60000; // Locale time offset in milliseconds
    let localIsoTime = new Date(Date.now() - offset).toISOString();
    return localIsoTime;
  }
};

export default dateTimeHelper;
